import { List } from 'src/app/models/list';
import { FilterOutput, FilterValue } from '../filter-objects';
/*Out Parameter*/

/************************Overview Page Data classes************************* */
export class DataFOveriviewDto {
  forecastDevelopmentChart: OverviewForecastDevelopmentChart[];
  forecastYearOnYearChart: OverviewForecastYearOnYearChart[];
  forecastSeasonalityChart: OverviewForecastSeasonalityChart[];
  forecastSeasonalityChartPers: OverviewForecastSeasonalityChart[];
  forecastChartCaption: ForecastChartCaption[];
  settingValue: SettingValue[];
  chartAlterGroup: ForecastChartCaption[];
  alterGroupData: ForecastAlterGroupValue[]; 
}

export class SettingValue {
  name: string;
  value: string;
}

export class ForecastAlterGroupValue {
  name: string;
  value: string;
  caption: string;
  orderBy: number;  
}

export class ForecastChartCaption {
  fieldName: string;
  captionName: string;
  orderBy: number; 
}

export class ForecastOverviewTableDto {
  fields: SelectStatementCaption[];
  values: ForecastOverviewTableData[];
}

export class SelectStatementCaption {
  columnName: string;
  caption: string;
  dataType: string;
}

export class ForecastOverviewTableData {
  forecastObjectClientId: string;
  segmentName: string;
  forecastMeasure1: string;
  permanentComment: string;
  issueResponse: string;
}

export class ForecastOverviewTableIssueResponse {
  listElement: string;
}

/*class Common*/
/* Overview Forecast Main Chart  */
export class OverviewForecastDevelopmentChart {
  yearMonth: string;
  month: number;
  tenderCampaign: number;
  forecastFinal: number;
  forecastPerito: number;
  actual: number;
  actualLY: number;
  actualLY2: number;
  actualLY3: number;
  lastReleased: number;
  actualClean: number;
  forecastKeyFigure1: number;
  forecastKeyFigure2: number;
  forecastKeyFigure3: number;
  forecastKeyFigure4: number;
  forecastKeyFigure5: number;
  forecastKeyFigure6: number;
  forecastKeyFigure7: number;
  forecastKeyFigure8: number;
  forecastKeyFigure9: number;
  forecastKeyFigure10: number;
  actual1: number;
  actual2: number;
  actual3: number;
}

/*  Overview Forecast Seasonality Chart */
export class OverviewForecastSeasonalityChart {
  season: string;
  act1Pct: number;
  act2Pct: number;
  act3Pct: number;
  fcPct: number;
  minValue: number;
  maxValue: number;
}

/* Overview Forecast Year On Year Chart */
export class OverviewForecastYearOnYearChart {
  rxy: number;
  finalForecast3: number;
  releasedForecast: number;
  actual: number;
}

/* Overview Forecast Selection Option */
export class OverviewForecastSelectionOption {
  lists: List[];
  custSelection: CustSelectionLst;
}

/* cust Selection Lst */
export class CustSelectionLst {
  overivewItemDisplay: string;
  overivewItemField: string;
  overivewItemTitle: string;
}

/* cust praramters */
export class ForecastOverviewPram {
  Action: string;
  Unit: string;
  UnitOfMeasure: string;
  SettingGroupId: number;
  filtersOptions: FilterOutput[] = [];
  filterValue : FilterValue[]=[]
}

export class ForecastDeepDiveMultiPram {
  Action: string;
  PageNumber: number; 
  RowsOfPage: number;
  MultipleFactor: number;
  filtersOptions: FilterOutput[] = [];
  OrderField: number;
  OrderSeq: number;
}
